import styled from "styled-components";

const Airport = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .city {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 230px;
    margin-right: 5px;
  }
`;

export default Airport;
